import cx from 'classnames';
import type { ChangeEvent, VoidFunctionComponent } from 'react';

import InputBase from '../../generic/Forms/InputBase';
import type { InputRenderProps } from '../../generic/Forms/InputBase';
import type { NumberInputProps } from '../../generic/Forms/NumberInput';

import styles from './NumberInputWithUnit.module.less';

type Props = Pick<NumberInputProps, 'label' | 'value' | 'isDisabled'> & {
  unit: string;
  //  We cast to a number to avoid type issues downstream.
  onChange: (value: number, event?: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

/**
 * NumberInputWithUnit is an input with an extra text span for a unit
 * such as "minutes" or "days".
 */
const NumberInputWithUnit: VoidFunctionComponent<Props> = ({
  unit,
  label,
  value,
  isDisabled,
  onChange,
}) => (
  <InputBase
    label={label}
    type="number"
    size="small"
    value={value}
    isDisabled={isDisabled}
    onChange={(updatedValue: string, event?: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      //  Cast to a number, because the input value is a string.
      onChange(Number(updatedValue), event)}
  >
    {(inputBaseProps: InputRenderProps) => (
      <span className={styles.wrapper}>
        <input
          {...inputBaseProps}
          className={cx(inputBaseProps.className, styles.input)}
        />
        <span className={styles.text}>
          {unit}
        </span>
      </span>
    )}
  </InputBase>
);

export default NumberInputWithUnit;
